import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  @media screen and (max-width: 479px) {
    width: 100%;
    .col-4 {
      width: 100% !important;
    }
  }
`;

export const CardContent = styled.div`
  width: 90%;
  height: 85%;
  background-color: ${theme.colors.darkBlue};
  border-radius: 20px;
  padding: 30px 0px 30px 60px;
  margin: 0 auto;

  label {
    width: 100% !important;
  }

  .button-box {
    display: flex;
    justify-content: center;
    padding-right: 60px;

    button {
      width: 25%;
    }

    button:first-of-type {
      margin-right: 10px;
    }

    button:last-of-type {
      margin-left: 10px;
    }
  }

  form {
    overflow: auto;
    height: 100%;
    padding-bottom: 200px;

    & .row-container {
      padding-right: 60px;
    }

    ::-webkit-scrollbar {
      width: 8px !important;
    }

    ::-webkit-scrollbar-track {
      background-color: ${theme.colors.blue800} !important;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.gray800} !important;
      border-radius: 0 !important;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0 !important;
    width: 100%;
    background-color: transparent;
    height: 90%;

    #form-factory {
      padding-bottom: 20px;
    }

    .row-container {
      padding-right: 10px !important;
    }

    .container-field {
      input:not([type="radio"]) {
        width: 100% !important;
      }
    }

    label {
      font-size: 14px;

      span {
        font-size: 16px;
        width: 35px;
        height: 35px;
        min-width: 35px;
        min-height: 35px;
      }
    }

    .container-form {
      margin-bottom: 0;
      width: 100% !important;
    }

    .p-dropdown {
      background-color: ${theme.colors.blue900} !important;
    }

    .p-dropdown-items {
      background-color: ${theme.colors.blue900} !important;
    }
  }
`;
